// Module
var code = "<ngx-forgot-password (on-back)=\"$ctrl.login()\"></ngx-forgot-password>";
// Exports
module.exports = code;